import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 *测试信息
 * @param params
 * 
*/

export const questionInfo = params => Http.get(`${baseUrl}/sz/team/exam/info`, { params })

/**
 *提交测试
 * @param params
 * 
*/

export const submit = params => Http.post(`${baseUrl}/sz/team/exam/submit`,  params )

/**
 *岗位推荐
 * @param params
 * 
*/

export const postRecommend = params => Http.get(`${baseUrl}/sz/team/exam/recommend`, { params })

/**
 *分配岗位
 * @param params
 * 
*/

export const assignment = params => Http.post(`${baseUrl}/sz/team/exam/distribution`,  params )

